import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@mui/material';

export const LoginButton = (props: ButtonProps) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <Button variant={'contained'} onClick={handleLogin} {...props}>
      Přihlásit se
    </Button>
  );
};
